import React from 'react';

const GetTechnicalIcon = () => {
  return (
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.97222 10.6867C7.97222 11.2233 7.56 11.6667 7 11.6667C6.45556 11.6667 6.02 11.2311 6.02 10.6867C6.02 10.1344 6.45556 9.71444 7 9.71444C7.55222 9.71444 7.97222 10.1422 7.97222 10.6867ZM6.99222 2.33333C5.61556 2.33333 4.67444 3.22778 4.32444 4.27L5.6 4.80667C5.77111 4.28556 6.17556 3.65556 7 3.65556C8.26 3.65556 8.50889 4.83778 8.06556 5.46778C7.64556 6.06667 6.92222 6.47111 6.54111 7.14778C6.23778 7.68444 6.3 8.30667 6.3 8.68778H7.71556C7.71556 7.96444 7.77 7.81667 7.88667 7.59111C8.19 7.03111 8.75 6.76667 9.34111 5.90333C9.87 5.12556 9.66778 4.06778 9.32556 3.50778C8.92889 2.85444 8.14333 2.33333 6.99222 2.33333ZM12.4444 1.55556H1.55556V12.4444H12.4444V1.55556ZM12.4444 0C13.3 0 14 0.7 14 1.55556V12.4444C14 13.3 13.3 14 12.4444 14H1.55556C0.7 14 0 13.3 0 12.4444V1.55556C0 0.7 0.7 0 1.55556 0H12.4444Z" fill="white"/>
</svg>


  );
};

export default GetTechnicalIcon;